export const CRAWLABLE_STEP_TYPES = ['lander', 'checkout']

export const ROBOTS_INDEXABLE = 'index, follow'
export const ROBOTS_BLOCKED = 'noindex, nofollow'

export function getRobotsContent(stepType) {
  return CRAWLABLE_STEP_TYPES.includes(stepType)
    ? ROBOTS_INDEXABLE
    : ROBOTS_BLOCKED
}

export function getRobotsMeta(stepType) {
  return {
    hid: 'robots',
    name: 'robots',
    content: getRobotsContent(stepType)
  }
}

export function getFunnelStepHead(stepType) {
  return {
    meta: [getRobotsMeta(stepType)]
  }
}

export function isFunnelSlug(slug) {
  return /^[^/]+\/[^/]+\/[^/]+$/.test(slug)
}
